import { makeStyles } from "tss-react/mui";
import { MiChip, MiStackedTypography } from "@miplatform/components";
import { IBidResponse } from "@miplatform/types";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export function BidPopperContent({
  option,
  communityName,
  builderName,
  seriesGroupName,
  seriesName,
  assigneeName,
}: Readonly<BidPopperContentProps>) {
  const { classes, cx } = useStyles();

  return (
    <Box className={classes.popperContent}>
      <Box className={classes.headerBox}>
        <Typography className={classes.title}>{option.name}</Typography>
        <MiChip
          label={option.active ? "Active" : "Inactive"}
          className={cx(
            classes.statusChip,
            option.active ? classes.activeChip : classes.inactiveChip
          )}
        />
      </Box>
      <Box className={classes.communitySection}>
        <Typography className={classes.communityBuilderText}>
          {communityName || "--"} | {builderName || "--"}
        </Typography>
      </Box>
      <Box className={classes.detailsBox}>
        {[
          { title: "Series Group", description: seriesGroupName },
          { title: "Series", description: seriesName },
          { title: "Assignee", description: assigneeName },
        ].map((detail) => {
          return (
            <MiStackedTypography
              key={detail.title}
              title={detail.title}
              description={
                <Typography className={classes.stackedTypography}>
                  {detail.description || "--"}
                </Typography>
              }
            />
          );
        })}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  popperContent: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    width: 350,
  },
  headerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1, 2),
  },
  title: {
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.fontSize.large,
  },
  statusChip: {
    borderRadius: 2,
    height: 18,
    fontWeight: theme.fontWeight.regular,
    color: theme.palette.common.white,
    "& .MuiChip-label": {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  activeChip: {
    border: `1px solid ${theme.palette.green.main}`,
    backgroundColor: theme.palette.green.medium,
  },
  inactiveChip: {
    border: `1px solid ${theme.palette.red.main}`,
    backgroundColor: theme.palette.red.medium,
  },
  communitySection: {
    padding: theme.spacing(0, 2, 2, 2),
  },
  communityBuilderText: {
    fontSize: theme.fontSize.small,
    color: theme.palette.grey.main,
  },
  detailsBox: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    backgroundColor: theme.palette.grey.mediumLight,
    padding: theme.spacing(0, 2),
    borderBottomLeftRadius: theme.spacing(1),
    borderBottomRightRadius: theme.spacing(1),
  },
  stackedTypography: {
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.fontSize.small,
  },
}));

type BidPopperContentProps = {
  option: IBidResponse;
  communityName?: string;
  builderName?: string;
  seriesGroupName?: string;
  seriesName?: string;
  assigneeName?: string;
};
